import query from '@design/query';
import theme, { ThemeColorName } from '@design/theme';
import styled from 'styled-components';
import BlockStyles from './BlockStyles';
export interface BlockComponentProps {
  narrow?: boolean;
  squish?: boolean;
  width?: string;
  full?: boolean; //full bleed
  fullOnMobile?: boolean; //full bleed on mobile only
  background?: ThemeColorName; //inputs color for block that extends to the entire viewport
  backgroundInner?: ThemeColorName; //inputs color for area within the block that extends to the entire viewport
  children?: React.ReactNode;
  className?: string; // to allow styled components to be passed in
}
const Block = ({
  narrow,
  squish,
  background,
  backgroundInner,
  full,
  fullOnMobile,
  children,
  className,
  width,
}: BlockComponentProps) => {
  return (
    <BlockStyles
      $squish={squish}
      $background={background}
      $full={full}
      $fullOnMobile={fullOnMobile}
      $className={className}
    >
      <BlockInner $narrow={narrow} $width={width} $backgroundInner={backgroundInner}>
        {children}
      </BlockInner>
    </BlockStyles>
  );
};

export interface BlockInnerStylesProps {
  $narrow?: boolean;
  $width?: string;
  $backgroundInner?: ThemeColorName; //inputs color for area within the block that extends to the entire viewport
}

const BlockInner = styled.div<BlockInnerStylesProps>(
  ({ $narrow, $width, $backgroundInner }: BlockInnerStylesProps) => {
    // TODO: use styled components CSSObject Type
    const css: Record<string, any> = {
      boxSizing: 'border-box', // allows padding to size inner content
      width: '100%',
      margin: '0 auto',
      overflow: 'visible',
      // prevent margin collapse to preserve apparent padding when bg set
      // '&>*': { overflow: 'visible' },
    };

    // add background if specified
    if ($backgroundInner) {
      css.backgroundColor = theme.colors[$backgroundInner];
    }

    css[`@media (${query.atLeast.desktop})`] = {
      width: `${$narrow ? '83.3333%' : $width ? $width : '100%'}`,
    };

    return css;
  },
);

export default Block;
